export default __webpack_public_path__ + "static/media/HirkaBeko.f4af251f.jpg";